module.exports = __webpack_public_path__ + "img/clock.be642b04.png";